import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useApp } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';

export default function Newsletter() {
  const { user } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
    }
  };

  const issues = [
    { id: 1, title: 'Holiday Travel Survival Guide at SMF', date: 'Nov 15, 2023' },
    { id: 2, title: 'New Dining Options in Terminal B', date: 'Nov 01, 2023' },
    { id: 3, title: 'Parking Pro-Tips for Long Weekends', date: 'Oct 15, 2023' },
  ];

  return (
    <div className="p-4 pb-24 md:pb-8 max-w-lg mx-auto space-y-8">
      {/* Hero Section */}
      <div className="text-center pt-8 pb-4">
        <div className="mx-auto w-20 h-20 bg-blue-600/10 rounded-3xl flex items-center justify-center mb-6 text-blue-400 rotate-6 border border-blue-500/20">
          <SafeIcon icon={FiIcons.FiMail} className="text-4xl" />
        </div>
        <h2 className="text-3xl font-extrabold text-white mb-2 tracking-tight">The Holding Pattern</h2>
        <p className="text-amber-500 text-[10px] font-bold uppercase tracking-[0.2em] mb-4">
          Powered by <a href="https://elkgroveservicesnetwork.com" target="_blank" rel="noopener noreferrer" className="hover:underline">The Elk Grove Services Network</a>
        </p>
        <p className="text-slate-400 text-sm max-w-xs mx-auto leading-relaxed">
          Your weekly briefing on SMF wait times, regional travel hacks, and exclusive airport news.
        </p>
      </div>

      {/* Subscribe Box */}
      {!user.isLoggedIn && !subscribed ? (
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          className="bg-slate-850 p-6 rounded-3xl border border-slate-700 shadow-2xl relative overflow-hidden"
        >
          <div className="relative z-10 space-y-4">
            <div className="space-y-2">
              <h3 className="text-lg font-bold text-white">Get Notified</h3>
              <p className="text-xs text-slate-400">Join 2,500+ Elk Grove travelers who receive our weekly updates.</p>
            </div>
            <form onSubmit={handleSubscribe} className="space-y-4">
              <input 
                type="email" 
                required 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                placeholder="traveler@example.com" 
                className="w-full bg-slate-900 border border-slate-700 rounded-xl p-4 text-white focus:ring-2 focus:ring-blue-500 outline-none" 
              />
              <button 
                type="submit" 
                className="w-full bg-blue-600 hover:bg-blue-500 text-white font-extrabold py-4 rounded-xl transition-all shadow-lg shadow-blue-600/20"
              >
                Subscribe Free
              </button>
            </form>
            <div className="flex items-center justify-center space-x-2">
              <div className="h-px bg-slate-800 flex-1"></div>
              <span className="text-[10px] text-slate-500 font-bold uppercase">Or</span>
              <div className="h-px bg-slate-800 flex-1"></div>
            </div>
            <button 
              onClick={() => navigate('/profile')}
              className="w-full bg-slate-800 hover:bg-slate-700 text-slate-200 font-bold py-3 rounded-xl transition-all text-sm border border-slate-700"
            >
              Sign Up for Full Rewards
            </button>
          </div>
        </motion.div>
      ) : (
        <div className="bg-emerald-900/20 border border-emerald-500/30 p-6 rounded-2xl text-center text-emerald-400 flex flex-col items-center space-y-3">
          <div className="w-12 h-12 bg-emerald-500/20 rounded-full flex items-center justify-center">
            <SafeIcon icon={FiIcons.FiCheckCircle} className="text-2xl" />
          </div>
          <div>
            <p className="font-bold text-lg text-white">You're on the list!</p>
            <p className="text-xs text-emerald-400/80">Checking for new issues from The Elk Grove Services Network...</p>
          </div>
        </div>
      )}

      {/* Archives */}
      <div>
        <h3 className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-4 flex items-center">
          <SafeIcon icon={FiIcons.FiArchive} className="mr-2" /> Recent Briefings
        </h3>
        <div className="space-y-3">
          {issues.map(issue => (
            <a key={issue.id} href="#" className="block bg-slate-850 p-4 rounded-2xl border border-slate-800 hover:border-slate-600 transition-all group active:scale-95" >
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="font-bold text-slate-200 group-hover:text-blue-400 transition-colors">{issue.title}</h4>
                  <p className="text-[10px] text-slate-500 mt-1 font-mono uppercase tracking-tighter">{issue.date} • ISSUE #0{issue.id}</p>
                </div>
                <SafeIcon icon={FiIcons.FiArrowRight} className="text-slate-600 group-hover:text-blue-400 transition-colors mt-1" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}